import {SupportedNetwork} from "@tinymanorg/tinyman-js-sdk";
import {CSSProperties} from "react";
import {ProposalTypes} from "@walletconnect/types";

export const DEFAULT_PROJECT_ID = "9f201803598eb75e94bca27f66152866";
export const DEFAULT_RELAY_URL = "wss://relay.walletconnect.com";
export const DEFAULT_APP_METADATA = {
  name: "Tinyman",
  description:
    "Tinyman is a decentralized trading protocol which utilizes the fast and secure framework of the Algorand blockchain, creating an open and safe marketplace for traders, liquidity providers, and developers.",
  url: "https://tinyman.org/",
  icons: [
    "https://github.com/tinymanorg/brand/blob/main/Logo/Tinyman_Logo_Black.png?raw=true"
  ]
};
const ALGORAND_CHAINS: Record<SupportedNetwork, string> = {
  mainnet: "algorand:wGHE2Pwdvd7S12BL5FaOP20EGYesN73k",
  testnet: "algorand:SGO1GKSzyE7IEPItTxCByw9x8FmnrCDe"
};
const DEFAULT_CHAINS = [ALGORAND_CHAINS.mainnet, ALGORAND_CHAINS.testnet];

const FIREBLOCKS_WALLET_ID =
  "5864e2ced7c293ed18ac35e0db085c09ed567d67346ccb6f58a0327a75137489";

const WALLET_CONNECT_MODAL_OVERLAY_STYLES: CSSProperties = {
  top: "0",
  left: "0",
  animation: "none",
  position: "absolute",
  width: "100%",
  maxWidth: "var(--widget-width)",
  maxHeight: "var(--widget-height)",
  overflow: "hidden",
  borderRadius: "var(--container-border-radius)"
};

const WALLET_CONNECT_MODAL_STYLES: CSSProperties = {
  margin: "4px",
  overflowY: "auto",
  maxWidth: "calc(var(--widget-width) - 8px)",
  maxHeight: "calc(var(--widget-height) - 8px)",
  borderRadius: "var(--container-border-radius)"
};

const WALLET_CONNECT_MODAL_CARD_STYLES: CSSProperties = {
  borderRadius: "var(--container-border-radius)"
};

const DEFAULT_REQUIRED_NAMESPACES: ProposalTypes.RequiredNamespaces = {
  algorand: {
    chains: DEFAULT_CHAINS,
    methods: ["algo_signTxn"],
    events: []
  }
};

export {
  ALGORAND_CHAINS,
  DEFAULT_CHAINS,
  FIREBLOCKS_WALLET_ID,
  WALLET_CONNECT_MODAL_CARD_STYLES,
  WALLET_CONNECT_MODAL_OVERLAY_STYLES,
  WALLET_CONNECT_MODAL_STYLES,
  DEFAULT_REQUIRED_NAMESPACES
};
